export default __webpack_public_path__ + "static/media/feature-tal-4.778959b9.png";